<template>
    <div class="slim">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div class="row m-0">
            <div class="w-100 text-container col-12 col-sm-6 m-auto pl-5 pr-5 p-sm-1" :class="alignmentClass">
                <expandable-text class="py-4" :max-height="240" :text="content.text || ''"></expandable-text>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['block', 'providerId', 'context'],

        computed:{
            alignmentClass() {
                return 'text-' + this.align;
            }
        },

        data() {
            const content = JSON.parse(this.block.content);
            return {
                id: this.block.id,
                content: content,
                align: content.align || 'left',
                informationBlock: this.block.information_block,
            };
        },
    }
</script>

<style scoped>
.text-container {
    margin-bottom: 2em;
    text-align: left;
    margin-top: -14px !important; 
}
</style>
